export default __webpack_public_path__ + "images/9ba7e6eaccc52f92cfca4425b4395b91-menu-pet-water.svg";